<template>
  <div style="margin: 50px">
    <!--element which is going to render the Card-->
    <div class="e-card">
      <div class="e-card-title">FOIP Disclosure</div>
      <div class="e-card-separator"></div>
      <div class="e-card-content margin-color-verify-section">
        <p style="text-align: justify" v-html="staticMessage"></p>
        <div class="align-right">
          <ejs-checkbox
            label="I have read and agree to this statement"
            v-model="permit.foip"
            :checked="permit.foip"
            @change="controlNavigationToReview"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'FoipInfo',
  mounted() {
    this.$emit('controlNavigationToReview', this.permit.foip);
  },
  computed: {
    ...mapGetters({
      staticMessage: 'staticMessage',
      permit: 'permit',
    }),
  },
  methods: {
    controlNavigationToReview() {
      this.$emit('controlNavigationToReview', this.permit.foip);
    },
  },
};
</script>
